/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_Link_PolicyInputs */

const en_directory_submit_review_link_policy = /** @type {(inputs: Directory_Submit_Review_Link_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link policy`)
};

const zh_directory_submit_review_link_policy = /** @type {(inputs: Directory_Submit_Review_Link_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链接策略`)
};

/**
* | output |
* | --- |
* | "Link policy" |
*
* @param {Directory_Submit_Review_Link_PolicyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_link_policy = /** @type {((inputs?: Directory_Submit_Review_Link_PolicyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Link_PolicyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_link_policy(inputs)
	return zh_directory_submit_review_link_policy(inputs)
});
export { directory_submit_review_link_policy as "directory.submit.review.link_policy" }